export function detectPopupBlock(func, action) {
  const newWindow = func()
  if (
    !newWindow ||
    newWindow.closed ||
    typeof newWindow.closed === "undefined"
  ) {
    action()
  }
}

export function isInWidthSize(size) {
  const sizes = {
    xs: 767,
    md: 992,
    lg: 1200,
  }

  return getBrowserWidth() <= sizes[size]
}

export function getBrowserWidth() {
  return window.innerWidth
}

export function getBrowserHeight() {
  return Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.documentElement.clientHeight
  )
}

export function isInViewport(element) {
  const rect = element.getBoundingClientRect()
  const html = document.documentElement
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || html.clientHeight) &&
    rect.right <= (window.innerWidth || html.clientWidth)
  )
}

export function addEvent(elem, type, eventHandle) {
  /* eslint-disable no-param-reassign */
  if (elem === null || typeof elem === "undefined") {
    return
  }
  if (elem.addEventListener) {
    elem.addEventListener(type, eventHandle, false)
  } else if (elem.attachEvent) {
    elem.attachEvent(`on${type}`, eventHandle)
  } else {
    elem[`on${type}`] = eventHandle
  }
  /* eslint-enable no-param-reassign */
}

export function removeEvent(elem, type, eventHandle) {
  /* eslint-disable no-param-reassign */
  if (elem === null || typeof elem === "undefined") {
    return
  }
  if (elem.removeEventListener) {
    elem.removeEventListener(type, eventHandle, false)
  } else if (elem.detachEvent) {
    elem.detachEvent(`on${type}`, eventHandle)
  } else {
    elem[`on${type}`] = null
  }
  /* eslint-enable no-param-reassign */
}

export function reloadPage() {
  window.location.reload()
}

export default {
  detectPopupBlock,
  isInViewport,
  addEvent,
  removeEvent,
  reloadPage,
}
